import React from 'react';
import ThemeIcon from '../ThemeIcon/ThemeIcon';
import './Service.scss';

const Service = ({serviceList}) => {
    const {title, price, members, description, features, highlight, icon} = serviceList;
 
    return (
        <div className='col-lg-3 col-md-6 col-sm-12'>
           <div className="service-box">
                {highlight && <div className="highlight-badge">{highlight}</div>}
                
                <div className="service-icon">
                    <div className='icon-area'>
                        <ThemeIcon icon={icon} />
                    </div>
                </div>
                
                <div className="service-text">
                    <h3>{title}</h3>
                    <div className="price-section">
                        <div className="price">{price}</div>
                        <div className="members">{members}</div>
                    </div>
                    <p className="description">{description}</p>
                    
                    <div className="features-list">
                        {features.map((feature, index) => (
                            <div key={index} className="feature-item">
                                <span className="check-icon">✓</span>
                                <span>{feature}</span>
                            </div>
                        ))}
                    </div>
                    
                    <div className="service-action">
                        <a href="tel:6395947006" className="call-now-btn">
                            <span className="call-icon">📞</span>
                            Call Now
                        </a>
                    </div>
                </div>
           </div>
        </div>
    );
};

export default Service;